const resources = {
    pros: 'Pour mentionnés',
    cons: 'Inconvénients mentionnés'
};

module.exports = function getResource(label) {
    return resources[label];
};
